// Entry — mounts <App /> into #root. styles.css carries the Curro design
// system (light default + [data-theme="dark"]); reveal.js adds scroll-in
// animations as a progressive enhancement (disabled under reduced motion).

import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import "./styles.css";
import "./lib/reveal.js";
import App from "./App.jsx";

// Theme + direction are applied FOUC-safe by an inline script in index.html
// (before first paint); the Topbar toggle keeps them in sync thereafter.

createRoot(document.getElementById("root")).render(
  <StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </StrictMode>,
);
